import { campaignBodyHtml } from "@/utils/campaign-helpers";
import { cn } from "@/lib/utils";

/** Typography for the tags an operator-authored body can contain. */
// The outer block's margins are trimmed: spacing belongs BETWEEN paragraphs, and a body made
// of <p>s would otherwise sit 8px further from its card's title and bottom edge than a plain one.
const PROSE =
  "[&_a]:text-primary [&_a]:underline [&_li]:my-1 [&_ol]:list-decimal [&_ol]:pl-5 [&_p]:my-2 [&_ul]:list-disc [&_ul]:pl-5 [&>:first-child]:mt-0 [&>:last-child]:mb-0";

/**
 * Renders operator-authored body copy (campaign descriptions, T&C). The single
 * place that turns a stored body into markup, so every surface treats `\n\n`
 * paragraph delimiters and inline HTML the same way.
 */
export const RichText = ({
  body,
  className,
}: {
  body?: string | null;
  className?: string;
}) => {
  if (!body?.trim()) return null;

  return (
    <div
      className={cn("w-full font-body", PROSE, className)}
      dangerouslySetInnerHTML={{ __html: campaignBodyHtml(body) }}
    />
  );
};
